<template>
  <div class="about-page">
    <!-- Hero Header -->
    <section class="about-hero">
      <div class="app-container">
        <div class="about-hero__inner">
          <span class="eyebrow anim-fade-up">
            <i class="bi bi-shield-check text-flame"></i>
            {{ $t('about.eyebrow') }}
          </span>
          <h1 class="about-hero__title anim-fade-up anim-delay-1">
            {{ $t('about.titleA') }} <span class="text-flame">{{ $t('about.titleB') }}</span>
          </h1>
          <p class="about-hero__desc anim-fade-up anim-delay-2">
            {{ $t('about.desc') }}
          </p>
        </div>
      </div>
    </section>

    <!-- Content & Values Section -->
    <section class="section about-content">
      <div class="app-container">
        <!-- Highlights Bar -->
        <div class="about-stats anim-fade-up anim-delay-3">
          <div class="about-stat-card">
            <span class="about-stat-num text-flame">2024</span>
            <span class="about-stat-label">{{ $t('about.statsYear') }}</span>
          </div>
          <div class="about-stat-card">
            <span class="about-stat-num text-accent">Tanding &amp; Seni</span>
            <span class="about-stat-label">Kategori Kompetisi</span>
          </div>
          <div class="about-stat-card">
            <span class="about-stat-num text-success">Fair Play</span>
            <span class="about-stat-label">{{ $t('about.statsFairplay') }}</span>
          </div>
        </div>

        <!-- Pillar Cards Grid -->
        <div class="about-grid">
          <article class="ui-card ui-card--interactive about-card">
            <div class="about-card__icon text-flame">
              <i class="bi bi-eye-fill"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.visionTitle') }}</h3>
            <p class="about-card__text">
              Menjadi platform penyelenggara dan digitalisasi turnamen olahraga nomor satu di Indonesia yang menghubungkan atlet berbakat, official, dan penggemar dalam satu ekosistem terpadu.
            </p>
          </article>

          <article class="ui-card ui-card--interactive about-card">
            <div class="about-card__icon text-accent">
              <i class="bi bi-rocket-takeoff-fill"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.missionTitle') }}</h3>
            <p class="about-card__text">
              Menyelenggarakan kejuaraan dari tingkat lokal hingga nasional dengan tata kelola profesional, pendaftaran transparan, penyusunan bagan yang tertib, dan jadwal yang mudah diakses kontingen.
            </p>
          </article>

          <article class="ui-card ui-card--interactive about-card">
            <div class="about-card__icon text-success">
              <i class="bi bi-heart-pulse-fill"></i>
            </div>
            <h3 class="about-card__title">{{ $t('about.valuesTitle') }}</h3>
            <p class="about-card__text">
              Kami percaya olahraga adalah sarana membangun karakter, persatuan komunitas, dan pola hidup sehat. Setiap kompetisi kami rancang untuk menciptakan pengalaman membanggakan bagi seluruh peserta.
            </p>
          </article>
        </div>

        <!-- Story / Manifesto Section -->
        <div class="about-manifesto ui-card">
          <div class="about-manifesto__body">
            <h3 class="about-manifesto__title">Mengapa Memilih Arena Sport Digital?</h3>
            <div class="about-manifesto__features">
              <div class="about-feature-item">
                <i class="bi bi-check-circle-fill text-flame"></i>
                <div>
                  <strong>Sistem Terintegrasi Penuh</strong>
                  <p>Mulai dari verifikasi berkas peserta, jadwal pertandingan, hingga dokumentasi bagan terorganisir secara digital.</p>
                </div>
              </div>
              <div class="about-feature-item">
                <i class="bi bi-check-circle-fill text-flame"></i>
                <div>
                  <strong>Transparansi & Akurasi</strong>
                  <p>Informasi jadwal dan perubahan bagan dapat diakses secara publik dan instan oleh para manajer tim dan atlet.</p>
                </div>
              </div>
              <div class="about-feature-item">
                <i class="bi bi-check-circle-fill text-flame"></i>
                <div>
                  <strong>Dukungan Komunitas Nyata</strong>
                  <p>Kolaborasi aktif dengan federasi olahraga, klub sekolah, dan perguruan tinggi untuk mencetak bibit juara baru.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA Box -->
        <div class="about-cta ui-card ui-card--flame">
          <div class="about-cta__content">
            <h3 class="about-cta__title">{{ $t('about.ctaTitle') }}</h3>
            <p class="about-cta__desc">{{ $t('about.ctaDesc') }}</p>
            <div class="about-cta__actions">
              <router-link to="/detail" class="ui-btn ui-btn--primary ui-btn--md">
                <i class="bi bi-trophy-fill"></i> Lihat Turnamen
              </router-link>
              <a href="https://wa.me/628123456789" target="_blank" rel="noopener noreferrer" class="ui-btn ui-btn--secondary ui-btn--md">
                <i class="bi bi-whatsapp"></i> Hubungi Kami
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
};
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  padding-bottom: var(--space-16);
}

/* ═════════════════ HERO ═════════════════ */
.about-hero {
  position: relative;
  padding-block: var(--space-12) var(--space-10);
  background: var(--hero-bg);
  text-align: center;
  border-bottom: 1px solid var(--border-subtle);
}

@media (min-width: 768px) {
  .about-hero {
    padding-block: var(--space-20) var(--space-16);
  }
}

.about-hero__inner {
  max-width: 760px;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.about-hero__title {
  font-size: clamp(1.85rem, 5vw, 3.25rem);
  font-weight: 800;
  line-height: 1.25;
  margin-block: var(--space-4) var(--space-5);
  letter-spacing: -0.02em;
}

.about-hero__desc {
  font-size: clamp(var(--text-base), 2vw, var(--text-lg));
  color: var(--text-secondary);
  line-height: 1.65;
  margin: 0;
}

/* ═════════════════ STATS ═════════════════ */
.about-stats {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
  margin-block: calc(-1 * var(--space-8)) var(--space-10);
  position: relative;
  z-index: 3;
}

@media (min-width: 640px) {
  .about-stats {
    grid-template-columns: repeat(3, 1fr);
    margin-block: calc(-1 * var(--space-10)) var(--space-12);
  }
}

.about-stat-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-xl);
  padding: var(--space-6) var(--space-4);
  text-align: center;
  box-shadow: var(--shadow-md);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.about-stat-num {
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 800;
  line-height: 1.1;
  font-family: var(--font-heading);
}

.about-stat-label {
  font-size: var(--text-xs);
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
}

/* ═════════════════ VALUE CARDS ═════════════════ */
.about-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-6);
  margin-bottom: var(--space-10);
}

@media (min-width: 768px) {
  .about-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.about-card {
  padding: var(--space-6);
  border-radius: var(--radius-2xl);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
}

.about-card:hover {
  transform: translateY(-4px);
}

.about-card__icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-lg);
  background: var(--accent-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.about-card__title {
  font-size: var(--text-xl);
  font-weight: 700;
  margin: 0;
}

.about-card__text {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

/* ═════════════════ MANIFESTO ═════════════════ */
.about-manifesto {
  padding: var(--space-8);
  border-radius: var(--radius-2xl);
  margin-bottom: var(--space-10);
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
}

@media (min-width: 768px) {
  .about-manifesto {
    padding: var(--space-10);
  }
}

.about-manifesto__title {
  font-size: clamp(1.25rem, 2.5vw, var(--text-2xl));
  margin: 0 0 var(--space-6);
  font-weight: 700;
  text-align: center;
}

.about-manifesto__features {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-6);
}

@media (min-width: 768px) {
  .about-manifesto__features {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--space-8);
  }
}

.about-feature-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}

.about-feature-item i {
  font-size: 1.25rem;
  margin-top: 2px;
  flex-shrink: 0;
}

.about-feature-item strong {
  display: block;
  font-size: var(--text-base);
  margin-bottom: 4px;
  color: var(--text-primary);
}

.about-feature-item p {
  font-size: var(--text-xs);
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
}

@media (min-width: 768px) {
  .about-feature-item p {
    font-size: var(--text-sm);
  }
}

/* ═════════════════ CTA ═════════════════ */
.about-cta {
  padding: var(--space-8) var(--space-6);
  border-radius: var(--radius-2xl);
  text-align: center;
  max-width: 860px;
  margin-inline: auto;
  border: 1px solid color-mix(in srgb, var(--flame-500) 25%, var(--border-default));
}

@media (min-width: 768px) {
  .about-cta {
    padding: var(--space-12) var(--space-8);
  }
}

.about-cta__title {
  font-size: clamp(1.35rem, 3vw, var(--text-3xl));
  font-weight: 800;
  margin: 0 0 var(--space-3);
}

.about-cta__desc {
  font-size: var(--text-base);
  color: var(--text-secondary);
  margin: 0 auto var(--space-6);
  max-width: 48ch;
}

.about-cta__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
}
</style>